import get from "es-toolkit/compat/get";
import { formatUnknown } from "src/omni-common/utils/formatUnknown";

import { ToastType } from "./types";

export const extractToastError = ({
  error,
  type,
  message,
}: {
  error?: unknown;
  type?: ToastType;
  message?: string;
}): unknown => {
  // HTTP error with response data.
  if (get(error, "response.data")) {
    return get(error, "response.data");
  }

  // Other error.
  if (error !== undefined) {
    return JSON.stringify(formatUnknown(error));
  }

  // Message as error.
  if (type === "ERROR" && message !== undefined) {
    return message;
  }

  return null;
};

export const resolveToastMessage = (
  error: unknown,
  extractedError: unknown,
  message: string | undefined,
): string =>
  (typeof error === "object" &&
    get(error, "response.status") === 403 &&
    "You don't have permission to perform this action") ||
  (typeof error === "object" &&
    get(error, "response.status") === 404 &&
    "API endpoint not found") ||
  (typeof extractedError === "object" &&
    extractedError !== null &&
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    (get(extractedError, "message") || get(extractedError, "error"))) ||
  // String error.
  (typeof extractedError === "string" && extractedError) ||
  // Object error.
  (extractedError !== null && JSON.stringify(extractedError)) ||
  // Actual message.
  message ||
  // Empty message.
  "";
